export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

// 将小写数字金额 转成 大写金额
export function dealBigMoney (n) {
  if (n) {
    var fraction = ['角', '分']
    var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    var unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
    var head = n < 0 ? '负' : ''
    n = Math.abs(n)

    var s = ''

    for (var i = 0; i < fraction.length; i++) {
      // 最终修正：直接取末位数字
      const decimalValue = Math.floor(n * Math.pow(10, i + 1)) // 6657.69 → i=0时得66576，i=1时得665769
      const digitIndex = decimalValue % 10 // 66576%10=6（角），665769%10=9（分）
      s += (digit[digitIndex] + fraction[i]).replace(/零./, '')
    }

    s = s || '整'
    n = Math.floor(n)

    for (let i = 0; i < unit[0].length && n > 0; i++) {
      var p = ''
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p
        n = Math.floor(n / 10)
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
  }
}

// 税金计算    n：发票金额    m：税率
export function taxComputation (n, m) {
  let a = (n / (1 + (m / 100))).toFixed(2)
  return (a * (m / 100)).toFixed(2)
}

// 金额单位换算(元、万、亿)
export function formatAmount (money) {
  if (parseFloat(money).toString() === 'NaN') {
    return '0元'
  } else {
    // 换算 单位
    let unit = ''
    // 正数、负数
    if (money > 0) {
      if (money >= 100000000) {
        unit = '亿'
        money /= 100000000
      } else if (money >= 10000) {
        unit = '万'
        money /= 10000
      } else {
        unit = '元'
      }
    } else {
      if (money <= -100000000) {
        unit = '亿'
        money /= 100000000
      } else if (money <= -10000) {
        unit = '万'
        money /= 10000
      } else {
        unit = '元'
      }
    }
    // 是否需要 四舍五入
    if (money % 1 !== 0 && String(money).split('.')[1].length > 2) {
      money = money.toFixed(2)
    }
    return money + ' ' + unit
  }
}

// 将小写金额转转换为大写金额 兼容正负数
export function dealBigMoneys (money) {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
  let head = money < 0 ? '负' : ''
  money = Math.abs(money)
  let s = ''
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(money * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  money = Math.floor(money)
  for (let i = 0; i < unit[0].length && money > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && money > 0; j++) {
      p = digit[money % 10] + unit[1][j] + p
      money = Math.floor(money / 10)
    }
    s = p.replace(/(零.)*零$/, '') + unit[0][i] + s
  }
  return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}



// WEBPACK FOOTER //
// ./src/utils/common.js